import axios, { AxiosInstance } from "axios";
import ErrorHandler from "utils/ErrorHandler";
import LocalStorage from "utils/LocalStorage";
import AuthService from "./Auth";
import createAuthRefreshInterceptor from "axios-auth-refresh";

const createApi = (baseUrl: string): AxiosInstance => {
    const api = axios.create({
        baseURL: baseUrl,
    });

    const refreshAuthLogic = async (failedRequest: any) => {
        try {
            const response = await AuthService.renewToken();
            const { access_token } = response.data;
            LocalStorage.setToken(response.data);
            failedRequest.response.config.headers['Authorization'] = `Bearer ${access_token}`;
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    };

    createAuthRefreshInterceptor(api, refreshAuthLogic);

    api.interceptors.request.use(
        (config) => {
            const token = LocalStorage.getAccessToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    api.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;

            if (error.response) {
                const { status } = error.response;

                if (status === 402) {
                    AuthService.logout();
                } else if (status !== 401) {
                    ErrorHandler({
                        error,
                        className: "test",
                        hasCancel: error.config.url?.includes("upload-finance-report"),
                    });
                }
            }

            return Promise.reject(error);
        }
    );

    return api;
};

export default createApi;